import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScaleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"scale"}/>
}
